import { BaseYcState, RegisterYCState } from '@yourcause/common/state';
import { Country, Region } from '../typings/location.typing';

@RegisterYCState()
export class CountriesState extends BaseYcState {
  readonly countries: Country[];
  readonly regions: {
    [countryName: string]: Region[];
  } = {};
}
